
<template>
  <v-app id="hefctemp">
    <v-main>
    <v-container fluid>  
      <div style="margin-left: 20px"><h1>Host Proforma Invoices</h1></div>
      <div style="margin-left: 20px"><h5>{{ this.hefctemp.length }} invoices found</h5></div>
      <v-row cols="12" dense style="display: flex; flex-direction: row; align-items: center; padding-top: 4px; padding-bottom: 8px;">
        <div style="width: 300px !important; margin-left: 20px">
          <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
        </div>
        <v-btn small color="success" @click="confirmOfficialDialog()" class="ml-4 mr-4" :disabled="this.toggled_hefctemp.length===0">Make selected official {{ getNumSelected() }}</v-btn>
        <v-btn small color="primary" @click="sendTo()" class="mr-4 no-uppercase" :disabled="this.toggled_hefctemp.length===0">SEND SELECTED TO {{ this.email }}  {{ getNumSelected() }}</v-btn>
        <v-btn small color="warning" @click="confirmDeleteDialog()" class="delete-button" :disabled="this.toggled_hefctemp.length===0">delete selected {{ getNumSelected() }}</v-btn>
      </v-row>        
      <v-data-table id="x" :headers="getHeaders()" :items="hefctemp" :disable-pagination=true
                          hide-default-footer item-key="hefc_nr" :loading="loading"
                          loading-text="Loading data...please wait" fixed-header :search="search"
                          show-select :single-select="false" v-model="toggled_hefctemp"
                          @toggle-select-all="clickAllItems"                          
                          :height="wInnerHeight">   
        <template v-slot:item.hefc_nr="{ item }">
          <div @click="$router.open('/eign/hefc/onHefcTmp/' + item.hefc_encrid)" class="clickable">{{ item.hefc_nr }}</div>
        </template>  
        <template v-slot:item.hefc_dt_iso="{ item }">
          <span>{{ item.hefc_dt }}</span>
        </template>      
        <template v-slot:item.sent="{ item }">
          <span v-if="item.sent"><v-icon>mdi-email-outline</v-icon></span><span v-else></span>
        </template>                              
      </v-data-table>        
    </v-container> 
    </v-main>
    <navBar title="Ares - Finance" :home="true" type="hefc"/>
    <standard_dialog ref="std_dialog" />  
    <standard_confirm ref="std_confirm" @confirm="confirm"/>  
    <please_wait ref="wait" :isPersistent="true" display_text="Sending..." :timerInterval="500"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import standard_dialog from '@/components/ui/standard_dialog.vue';
import standard_confirm from '@/components/ui/confirm_dialog.vue';
import please_wait from '@/components/pleaseWait.vue'

export default {
  components: {
    navBar,
    standard_dialog,
    standard_confirm,
    please_wait
  },
  data() {
    return {
      hefctemp: [],
      toggled_hefctemp:[],
      queue: [],
      loading: false,
      search: '',
      email: '',
      wInnerHeight: window.innerHeight - 230, 
    }  
  },
  mounted() {
    this.getData()
  },
  watch: {
    // als je gaat zoeken dan vervalt je selectie je kunt anders een niet zichtbare selectie hebben !! Gevaarlijk bij gebruik van verwijderen
    search: {
        handler(){
          this.toggled_hefctemp = [];
        } 
    },
  },    
  methods: {  
    getData(){
        this.loading = true;
        this.toggled_hefctemp = []
        this.$axios
        .post("ares/json/ares/eign/hefc/searchHefcTmp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHefcTmp"
          },
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hefctemp = res.data.searchHefcTmp;
            this.email = res.data.gebr_email
          }
          this.loading = false;
        })        
    },
    confirm(data){
      switch(data) {
        case 'del':
          this.deleteHefc()
          break;
        case 'con':
          this.makeOfficial()
          break;
      } 
    },  
    confirmDeleteDialog(){
        this.$refs.std_confirm.open({
          title: 'Delete multiple proforma invoices',
          message: `<p>You are about to delete <b>${this.toggled_hefctemp.length}</b> proforma invoice(s)</p><p>Are you sure you want to this?</p>`,
          type: 'del',
          cancel: 'cancel',
          confirm: 'confirm'
        })
    },    
    confirmOfficialDialog(){
        this.$refs.std_confirm.open({
          title: ' Set multiple proforma invoices to real invoices',
          message: `<p>You are about to make <b>${this.toggled_hefctemp.length}</b> proforma invoice(s) official and send the invoice to the host</p>
                    <p>(Sending the invoice may take some time)</p>
                    <p>Are you sure you want to this?</p>`,
          type: 'con',
          cancel: 'cancel',
          confirm: 'confirm'
        })      
    },        
    deleteHefc(){
      this.$refs.wait.open();
      this.queue = []
      this.toggled_hefctemp.forEach((el) => {
        const promise = this.deleteOneHefc(el.hefc_encrid)
        this.queue.push(promise)
      })
      Promise.all([...this.queue]).then(() => {
        this.$refs.wait.close();
        if(this.queue.length!==0) this.$refs.std_dialog.open('info', 'Info', `${this.queue.length} proforma invoice where deleted.`);    
        this.getData();
      });      
    },
    deleteOneHefc(encrid){
      return this.$axios
        .post("ares/json/ares/eign/hefc/rmHefc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHefc"
          },
          rmHefc: {
            hefc_encrid: encrid
          }
        })
    },
    makeOfficial(){
      this.$refs.wait.open();
      this.queue = []
      this.toggled_hefctemp.forEach((el) => {
        const promise = this.makeOneProformaOfficial(el.hefc_encrid)
        this.queue.push(promise)        
      })
      Promise.all([...this.queue]).then(() => {
        this.$refs.wait.close();      
        if(this.queue.length!==0) this.$refs.std_dialog.open('info', 'Info', `${this.queue.length} proforma invoices where made official and sent to the host(s).`);    
        this.getData();
      });         
    },
    makeOneProformaOfficial(encrid){
      return this.$axios
        .post("ares/json/ares/eign/hefc/tmpHefcToHefc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "tmpHefcToHefc"
          },
          tmpHefcToHefc: {
            hefc_encrid: encrid
          }
        })
    },
    sendMailTo(encrid){
      this.$axios
        .post("ares/json/ares/eign/hefc/sentHefcByEmail.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "sentHefcByEmail"
          },
          sentHefcByEmail: {
            hefc_encrid: encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }
        })
        // asynchroon bijwerken wachten op alle mails duurt lang en is onnodig
        this.hefctemp.forEach((el) => {
          if(el.hefc_encrid === encrid){
            el.sent = true        
          }
        })   
    },
    sendTo(){
      let ml = 0 
      this.toggled_hefctemp.forEach((el) => {
        if(!el.sent) { 
          this.sendMailTo(el.hefc_encrid)
          ml++
        }
      })        
      if(ml!==0) this.$refs.std_dialog.open('info', 'Info', `${ml} mails where sent to ${this.email}. Processing them may take some time.`);    
      else this.$refs.std_dialog.open('warning', 'Warning', `No mails where sent to ${this.email}. The selection has already been sent`);
      
    },
    getNumSelected(){
      return this.toggled_hefctemp.length===0?'':`(${this.toggled_hefctemp.length})` 
    },
    getHeaders() {
        return [
            { text: "Number", value: "hefc_nr", sortable: true},
            { text: "Description", value: "hefc_oms", sortable: true},
            { text: "Timestamp", value: "hefc_dt_iso", sortable: true},
            { text: "Host", value: "eign_naam", sortable: true},
            { text: "Country", value: "land_code", sortable: true},
            { text: "User", value: "gebr_code", sortable: false},
            { text: "Sent", value: "sent", sortable: false},
        ]
      },    
  }       
}

</script> 
<style scoped>
.clickable{
  color: blue !important; 
  text-decoration: underline !important; 
  cursor: pointer;
}
.delete-button{
  margin-left: 100px !important;
}
.no-uppercase {
  text-transform: unset !important;
}
</style>